import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import dubai1 from "../assets/places/dubai/dubai13.jpg";
import japanBackground from "../../src/assets/places/japan/japan9.jpg";
import brazil1 from "../../src/assets/places/brazil/brazil5.jpg";
import thailand4 from "../../src/assets/places/paris/thailand13.jpg";
import malaysia1 from "../../src/assets/places/malaysia/malaysia.jpg";
import bali3 from "../assets/places/bali/bali3.jpg";
import paris3 from "../assets/places/paris/paris4.jpg";
import australia from "../assets/places/paris/australia.jpg";
import singapur from "../assets/places/singapur/singapur13.jpg";
import maldives from "../assets/places/paris/maldives8.jpg";
import dubai2 from "../assets/places/dubai/dubai1.jpg";
import dubai3 from "../assets/places/dubai/dubai2.jpg";
import dubai4 from "../assets/places/dubai/dubai.jpg";
import dubai5 from "../assets/places/dubai/dubai4.jpg";
import bali6 from "../assets/places/paris/bali13.jpg";
import singapur13 from "../assets/places/singapur/singapur13.jpg";
import { FaArrowLeft, FaUser, FaCalendarAlt } from "react-icons/fa"; // Importing the back icon

const blogsData = [
  {
    id: 4,
    image: bali3,
    date: "2024-12-31",
    images: [
      japanBackground,
      brazil1,
      malaysia1,
      maldives,
      paris3,
      thailand4,
      bali6,
      singapur13,
      dubai4,
      australia
    ],
    title:
      " Best 10 International Destinations for a Magical New Year’s Eve Getaway",
    description: `
    Best 10 International Destinations for a Magical New Year’s Eve Getaway

    As the year comes to an end, it’s time to plan the perfect New Year’s Eve getaway. TripDekhoo.com, your trusted travel agency for international trips, brings you the best destinations to make your New Year’s Eve magical and unforgettable. From vibrant celebrations to serene escapes, these ten destinations offer unique experiences that cater to every traveler’s dream.
    
    1. Japan – Experience Traditional and Modern Celebrations
    
    Cost: Starting from Rs 89,999
    
    Japan offers a fascinating mix of tradition and modernity during New Year’s Eve. Visit Tokyo for its dazzling fireworks and countdown parties, or explore Kyoto’s serene temples to witness the ringing of bells, a tradition known as “Joya no Kane.” Whether you seek a lively celebration or a tranquil retreat, Japan has it all.
    
    2. Thailand – Party in Paradise
    
    Cost: Starting from Rs 39,999
    
    Known for its lively beach parties, Thailand is a top destination for New Year’s Eve. Head to Bangkok for grand celebrations or Phuket and Koh Phangan for epic beach parties. The warm weather and festive atmosphere make Thailand a perfect escape from winter chills.
    
    3. Dubai – Witness Extravagance at its Best
    
    Cost: Starting from Rs 45,999
    
    Dubai’s New Year’s Eve celebrations are nothing short of spectacular. The iconic fireworks at the Burj Khalifa and luxurious gala dinners make Dubai a favorite for travelers seeking grandeur and excitement. Don’t miss the mesmerizing light shows and live entertainment.
    
    4. Malaysia – Affordable Adventure and Festivities
    
    Cost: Starting from Rs 14,999
    
    Malaysia offers a blend of cultural and modern New Year’s Eve experiences. Celebrate in Kuala Lumpur with its famous fireworks at the Petronas Towers or head to Langkawi for a more laid-back vibe. With its affordability, Malaysia is perfect for budget-conscious travelers.
    
    5. Paris – Romance and Elegance
    
    Cost: Starting from Rs 78,999 (7 nights/8 days)
    
    The City of Lights transforms into a romantic wonderland during New Year’s Eve. Enjoy the dazzling Eiffel Tower light show, indulge in gourmet French cuisine, and take a romantic cruise along the Seine River. Paris offers an elegant way to ring in the New Year.
    
    6. Maldives – Luxury and Serenity
    
    Cost: Starting from Rs 62,999 (4 nights/3 days)
    
    Escape to the Maldives for a luxurious and serene New Year’s Eve. Relax in an overwater villa, enjoy private beach dinners, and watch fireworks over the Indian Ocean. It’s the ultimate destination for couples and those seeking tranquility.
    
    7. Bali – Tropical Bliss
    
    Cost: Starting from Rs 35,999
    
    Bali combines vibrant nightlife with natural beauty for an unforgettable New Year’s Eve. Dance the night away at beach clubs in Seminyak, or experience cultural festivities in Ubud. Bali’s warm hospitality and stunning landscapes make it a favorite among travelers.
    
    8. Singapore – Futuristic Celebrations
    
    Cost: Starting from Rs 42,999
    
    Singapore’s Marina Bay Countdown is a highlight of New Year’s Eve celebrations. Enjoy live performances, incredible light shows, and breathtaking fireworks. Singapore also offers excellent shopping and dining experiences to complement your trip.
    
    9. Brazil – Festive Vibes on Copacabana Beach
    
    Cost: Starting from Rs 24,999 (4 days/3 nights)
    
    Brazil’s Copacabana Beach is famous for its vibrant New Year’s Eve celebrations. Join millions of revelers dressed in white, enjoy live music, and watch the spectacular fireworks over the Atlantic Ocean. It’s a truly unique way to welcome the New Year.
    
    10. Australia – Be the First to Celebrate
    
    Cost: Starting from Rs 1,25,999
    
    Be among the first in the world to welcome the New Year in Australia. Sydney’s Harbour Bridge fireworks are iconic, drawing visitors from around the globe. Explore Melbourne’s street parties or enjoy a laid-back celebration on Australia’s pristine beaches.
    
    Plan Your New Year’s Getaway with TripDekhoo.com
    
    Whether you’re seeking adventure, romance, or a vibrant party, these destinations promise an unforgettable start to the New Year. Visit our website TripDekhoo.com or contact us today to book your dream international trip. Let us make your New Year’s Eve magical!    
    `,
    author: "Diksha",
  },
  {
    id: 1,
    image: bali6,
    date: "2024-12-01",
    title: "Exploring the Beauty of Bali",
    images: [],
    description: `
      **Introduction**
  
      Bali, an Indonesian paradise known for its forested volcanic mountains, iconic rice paddies, beaches, and coral reefs, is a destination that has something for everyone. Whether you're seeking adventure, relaxation, or cultural enrichment, Bali delivers an unforgettable experience.
  
      **Natural Beauty**
  
      The island is home to stunning natural landscapes. From the towering Mount Agung, an active volcano that offers breathtaking sunrise views, to the tranquil beaches of Seminyak and Kuta, Bali's natural beauty is awe-inspiring. Ubud, the cultural heart of Bali, is surrounded by lush jungle and terraced rice paddies, making it perfect for nature walks and scenic photography.
  
      **Cultural Experiences**
  
      Bali's rich culture is evident in its numerous temples, traditional dances, and vibrant festivals. The island is dotted with thousands of temples, each with its own unique charm. The Uluwatu Temple, perched on a cliff overlooking the ocean, is famous for its dramatic setting and traditional Kecak dance performances at sunset. Another must-visit is the Tirta Empul Temple, known for its holy spring water where locals perform purification rituals.
  
      **Local Cuisine**
  
      Balinese cuisine is a feast for the senses. From the famous Babi Guling (suckling pig) to Nasi Goreng (fried rice), the flavors are bold and unforgettable. Street food markets, like those in Gianyar, offer a chance to sample local dishes in a lively atmosphere. Don't miss trying the fresh seafood in Jimbaran Bay, where you can dine on the beach with your toes in the sand.
  
      **Adventure Activities**
  
      For adventure seekers, Bali offers a plethora of activities. Surfing is hugely popular, with world-renowned breaks at Uluwatu and Padang Padang. Diving and snorkeling are also top activities, with the coral reefs around Nusa Penida and the USS Liberty shipwreck in Tulamben being major highlights. For those who prefer land-based adventures, white-water rafting on the Ayung River and hiking through the rice terraces of Tegallalang are excellent options.
  
      **Relaxation and Wellness**
  
      Bali is also a haven for those seeking relaxation and wellness. The island is dotted with luxury spas offering traditional Balinese massages and holistic treatments. Ubud, in particular, is known for its yoga retreats and wellness centers, where visitors can rejuvenate their mind, body, and spirit. Many resorts also offer wellness packages that include healthy meals, meditation sessions, and spa treatments.
  
      **Accommodation Options**
  
      From budget-friendly guesthouses to luxurious beachfront resorts, Bali offers a wide range of accommodation options. Whether you want to stay in a traditional Balinese villa or a modern hotel, there's something to suit every taste and budget. Many accommodations also offer stunning views of the ocean, rice paddies, or mountains, providing the perfect backdrop for a relaxing stay.
  
      **Shopping and Nightlife**
  
      Bali's shopping scene is diverse, ranging from local markets to high-end boutiques. Ubud is known for its artisan markets, where you can buy handmade crafts, jewelry, and textiles. Seminyak and Kuta, on the other hand, offer a mix of international brands and local designers. When the sun sets, Bali's nightlife comes alive with beach clubs, rooftop bars, and nightclubs offering entertainment into the early hours.
  
      **Conclusion**
  
      Bali is a destination that truly has it all. Whether you're looking to immerse yourself in culture, explore nature, enjoy delicious food, or simply relax, this Indonesian island paradise will leave you with memories to last a lifetime.
    `,
    author: "Author One",
  },
  {
    id: 2,
    image: dubai1,
    date: "2024-12-02",
    title: "The Wonders of Dubai",
    images: [],
    description: `
      **Introduction**
  
      Dubai, a city known for its futuristic architecture, luxury shopping, and vibrant nightlife, is a destination that constantly reinvents itself. Located in the United Arab Emirates, Dubai offers a mix of traditional culture and modern innovation.
  
      **Iconic Landmarks**
  
      Dubai is home to some of the world's most iconic landmarks. The Burj Khalifa, the tallest building in the world, offers panoramic views of the city from its observation decks. The Palm Jumeirah, an artificial archipelago, is another marvel of engineering, featuring luxury hotels, villas, and entertainment venues. The Dubai Fountain, located at the base of the Burj Khalifa, puts on a spectacular water and light show daily.
  
      **Cultural Experiences**
  
      Despite its modern facade, Dubai has a rich cultural heritage. The Al Fahidi Historic District, with its narrow lanes and traditional wind-tower architecture, offers a glimpse into the city's past. The Dubai Museum, housed in the Al Fahidi Fort, showcases the history and development of the emirate. Visitors can also explore the bustling souks (markets) of Deira, where they can shop for spices, textiles, and gold.
  
      **Luxury Shopping**
  
      Dubai is a shopper's paradise. The Dubai Mall, one of the largest shopping malls in the world, features over 1,200 stores, an indoor aquarium, and an ice rink. The Mall of the Emirates is another top shopping destination, known for its indoor ski slope. For a more traditional shopping experience, visit the Gold Souk and Spice Souk in Deira.
  
      **Adventure Activities**
  
      For those seeking adventure, Dubai offers plenty of options. Desert safaris are a popular activity, where visitors can experience dune bashing, camel riding, and sandboarding. The Dubai Marina is a hub for water sports, including jet skiing, parasailing, and yacht tours. Skydiving over the Palm Jumeirah offers an adrenaline rush and unbeatable views.
  
      **Dining and Nightlife**
  
      Dubai's dining scene is as diverse as its population. From high-end restaurants helmed by celebrity chefs to street food vendors, there's something to suit every palate. The city also boasts a vibrant nightlife, with beach clubs, rooftop bars, and nightclubs hosting international DJs. The Dubai Opera, located in Downtown Dubai, offers a range of performances, including opera, ballet, and concerts.
  
      **Relaxation and Wellness**
  
      Dubai is also a great destination for relaxation and wellness. Many luxury hotels offer world-class spas and wellness centers, where visitors can indulge in a range of treatments. The beaches of Jumeirah are perfect for a day of sunbathing and swimming, while the Dubai Miracle Garden provides a peaceful escape with its stunning floral displays.
  
      **Accommodation Options**
  
      From budget-friendly hotels to opulent resorts, Dubai offers a wide range of accommodation options. The Burj Al Arab, often referred to as the world's only seven-star hotel, is a symbol of luxury and extravagance. Other notable hotels include the Atlantis The Palm, the Armani Hotel, and the Address Downtown. For those seeking a unique experience, there are also desert resorts and traditional Bedouin-style accommodations.
  
      **Conclusion**
  
      Dubai is a city that never ceases to amaze. Its blend of modern innovation and traditional culture, combined with a range of activities and attractions, makes it a must-visit destination. Whether you're looking to shop, dine, explore, or relax, Dubai offers an unforgettable experience.
    `,
    author: "Author Two",
  },
  {
    id: 3,
    image: singapur13,
    date: "2024-12-03",
    title: "Singapore: A City of the Future",
    images: [],
    description: `
      **Introduction**
  
      Singapore, often referred to as the 'Lion City', is a global financial hub known for its modern architecture, lush green spaces, and multicultural heritage. This city-state in Southeast Asia offers a perfect blend of tradition and modernity.
  
      **Urban Wonders**
  
      Singapore's skyline is dominated by futuristic structures such as the Marina Bay Sands, a hotel and casino complex with an infinity pool offering breathtaking views of the city. Gardens by the Bay, a nature park spanning 101 hectares, features the iconic Supertree Grove and the climate-controlled Flower Dome and Cloud Forest. The Singapore Flyer, one of the world's largest observation wheels, provides a unique perspective of the city.
  
      **Cultural Heritage**
  
      Despite its modernity, Singapore is steeped in cultural heritage. Chinatown, Little India, and Kampong Glam are vibrant ethnic enclaves that offer a glimpse into the city's diverse cultural tapestry. The Sri Mariamman Temple, the Buddha Tooth Relic Temple, and the Sultan Mosque are must-visit religious sites. The Peranakan Museum and the National Museum of Singapore provide insights into the local history and culture.
  
      **Culinary Delights**
  
      Singapore is a food lover's paradise. The city's hawker centers, such as Maxwell Food Centre and Lau Pa Sat, offer a wide range of affordable and delicious local dishes. From Hainanese Chicken Rice to Chili Crab, the flavors are diverse and exciting. For a more upscale dining experience, visit one of the many Michelin-starred restaurants, such as Odette or Burnt Ends.
  
      **Nature and Recreation**
  
      Despite its urban landscape, Singapore offers plenty of green spaces for recreation and relaxation. The Singapore Botanic Gardens, a UNESCO World Heritage site, is a haven of tropical flora. Sentosa Island is a popular leisure destination, home to Universal Studios Singapore, S.E.A. Aquarium, and beautiful beaches. The Southern Ridges, a 10-kilometer trail connecting several parks, offers stunning views and a chance to experience the city's biodiversity.
  
      **Shopping and Entertainment**
  
      Singapore is a shopper's paradise, with Orchard Road being the main shopping belt. This 2.2-kilometer stretch is lined with malls, boutiques, and department stores offering a wide range of products. For a unique shopping experience, visit Haji Lane, a narrow street in Kampong Glam known for its independent boutiques and vibrant street art. In the evening, Clarke Quay and Marina Bay come alive with a variety of dining, entertainment, and nightlife options.
  
      **Events and Festivals**
  
      Singapore hosts a variety of events and festivals throughout the year. The Singapore Grand Prix, a Formula 1 night race, is a major highlight. The Singapore Food Festival, the Singapore Arts Festival, and the Great Singapore Sale are other popular events. Chinese New Year, Hari Raya Puasa, Deepavali, and Christmas are celebrated with great enthusiasm, reflecting the city's multicultural identity.
  
      **Accommodation Options**
  
      Singapore offers a wide range of accommodation options to suit different budgets and preferences. From luxury hotels like Raffles Singapore and The Fullerton Hotel to budget-friendly hostels and boutique hotels, there's something for everyone. Many hotels are centrally located, making it easy to explore the city's attractions.
  
      **Conclusion**
  
      Singapore is a city that truly has it all. Its blend of modern architecture, rich cultural heritage, diverse culinary scene, and abundant green spaces make it a unique and exciting destination. Whether you're visiting for business or leisure, Singapore promises an unforgettable experience.
    `,
    author: "Author Three",
  },
];

const BlogsDetailsNew = () => {
  const { title } = useParams();
  const renderParagraphWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+|(?:www\.)?[^\s]+\.[a-z]{2,})/gi;
    const parts = text.split(urlRegex);

    return parts.map((part, i) =>
      urlRegex.test(part) ? (
        <a
          key={i}
          href={part.startsWith("http") ? part : `https://${part}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 underline"
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  const navigate = useNavigate();
  const blog = blogsData.find(
    (b) =>
      b.title
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "") === title
  );

  if (!blog) {
    return <div>Blog not found</div>;
  }

  const { image, date, description, author } = blog;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-white text-gray-900 dark:bg-gray-900 dark:text-white"
    >
      <Helmet>
        <title>{`Blog: ${title}`}</title>
        <meta
          name="description"
          content="Explore the best international destinations for your New Year’s Eve getaway. Learn about Japan New Year Travel and other amazing international travel packages for your New Year celebrations!"
        />
        <meta
          name="keywords"
          content="Best 10 International Destinations, New Year’s Eve Getaway, Japan New Year Travel, New Year Celebrations, International Travel Packages, New Year Trips, TripDekhoo International Trips"
        />
        <meta name="author" content={author} />
        <meta property="og:title" content={`Blog: ${title}`} />
        <meta
          property="og:description"
          content="Explore the best international destinations for your New Year’s Eve getaway. Learn about Japan New Year Travel and other amazing international travel packages for your New Year celebrations!"
        />
        <meta property="og:image" content={image} />
        <meta property="og:type" content="article" />
      </Helmet>

      <div className="relative h-[40vh] md:h-[60vh] overflow-hidden">
        <motion.img
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.7 }}
          src={image}
          alt={title}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/30" />
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="absolute bottom-0 left-0 right-0 p-6 md:p-12 bg-gradient-to-t from-black/70 to-transparent"
        >
          <div className="container mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">
              {title.startsWith("-")
                ? title.slice(1).charAt(0).toUpperCase() +
                  title.slice(2).replace(/-/g, " ")
                : title.charAt(0).toUpperCase() +
                  title.slice(1).replace(/-/g, " ")}
            </h1>
            <div className="flex flex-wrap items-center gap-4 text-white/80">
              <div className="flex items-center gap-2">
                <FaUser className="h-4 w-4" />
                <span className="text-sm">{author}</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCalendarAlt className="h-4 w-4" />
                <span className="text-sm">
                  {new Date(date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="container mx-auto px-4 py-12 md:px-6 lg:px-36">
        <motion.button
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
          onClick={() => navigate("/blogsdetails")}
          className="group mb-8 flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900 dark:text-gray-400 dark:hover:text-white"
        >
          <FaArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          Back to Blogs
        </motion.button>

        <motion.article
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="prose prose-lg mx-auto dark:prose-invert"
        >
          {description.split("\n").map((paragraph, index) => {
            if (!paragraph.trim()) return null;

            const isHeading = paragraph.trim().startsWith("**");
            const isNumberedHeading = /^\d+\./.test(paragraph.trim());

            if (isHeading) {
              const headingText = paragraph.replace(/\*\*/g, "").trim();
              return (
                <motion.h2
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 * index }}
                  key={index}
                  className="text-2xl font-bold textColor mb-4"
                >
                  {headingText}
                </motion.h2>
              );
            }

            if (isNumberedHeading) {
              return (
                <motion.h3
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2 * index }}
                  key={index}
                  className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-3"
                >
                  {paragraph.trim()}
                </motion.h3>
              );
            }

            return (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index }}
                key={`paragraph-${index}`}
              >
                <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                  {renderParagraphWithLinks(paragraph.trim())}
                </p>

                {/* Check for country names and display the corresponding image */}
                {(() => {
                  const countries = [
                    "japan",
                    "brazil",
                    "malaysia",
                    "maldives",
                    "paris",
                    "thailand",
                    "bali",
                    "singapore",
                    "dubai",
                    "australia"
                  ];

                  // Find the country mentioned in the paragraph
                  const matchedCountry = countries.find((country) =>
                    paragraph.toLowerCase().includes(country)
                  );

                  // Get the index of the matched country
                  const countryIndex = matchedCountry
                    ? countries.indexOf(matchedCountry)
                    : -1;

                  // Display the corresponding image if a match is found and the image exists
                  if (countryIndex !== -1 && blog?.images?.[countryIndex]) {
                    return (
                      <img
                        src={blog.images[countryIndex]}
                        alt={`${matchedCountry} Image`}
                        className="md:w-1/2 md:h-1/2 w-full h-full object-cover rounded-lg shadow-lg my-4"
                        loading="lazy"
                      />
                    );
                  }

                  // If no specific country is found or no image exists, return null
                  return null;
                })()}
              </motion.div>
            );
          })}
        </motion.article>
      </div>
    </motion.div>
  );

  // Function to render paragraph with clickable links
};

export default BlogsDetailsNew;
